/* eslint-disable import/prefer-default-export */
import { createImageUrl } from '@/utils/helper/helperFunction';
import { domainNameEnums, saasDomains } from '@/utils/Domain';
import { domainName } from '@/utils/common/env.constants';
import { DescriptionPageEnums } from './enums';
import { IPartnerInstitute, IRecommendedCourse } from './Interfaces/RecommendedCourses';

export const fallbackImage =
  'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/62838310-32d8-436d-a9dd-53fb11a696b0.jpeg';
export const saasDomainCourseFallbackImage = '/images/ycmouCourseFallbackImage.png';
export const returnImageUrl = (url: string | undefined) => {
  if (!url) {
    if (saasDomains.includes(domainName as domainNameEnums)) return saasDomainCourseFallbackImage;
    return fallbackImage;
  }
  if (url?.startsWith('https')) return url;
  return createImageUrl(url);
};

export const descriptionPageCss = (caseType: string) => {
  switch (caseType) {
    case DescriptionPageEnums.HEADER:
      return 'h4';
    case DescriptionPageEnums.SUBHEADER:
      return 'body-small';
    default:
      return '';
  }
};

export const titleToSlug = (title: string) => {
  return title
    ?.toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/[^a-z0-9-]/g, '') // Remove non-alphanumeric characters and dashes
    .replace(/-+/g, '-') // Replace multiple dashes with single dash
    .replace(/^-*/, '') // Remove leading dashes
    .replace(/-*$/, ''); // Remove trailing dashes
};

export const checkCourseType = (url: string) => {
  if (url.includes('course')) return 'course';
  if (url.includes('masterclass')) return 'masterclass';
  return 'other';
};

export const getSlug = (url: string) => {
  const urlArray = url.trim().split('/');
  if (urlArray[urlArray.length - 1] === '') return urlArray[urlArray.length - 2];
  return urlArray[urlArray.length - 1];
};

const checkPartnerInstituteAlreadyPresent = (
  filteredPartnerInstitute: IPartnerInstitute[],
  partnerInstituteId: string
) => {
  if (filteredPartnerInstitute?.length === 0) return false;
  if (
    filteredPartnerInstitute?.some(
      (partnerInstitute: IPartnerInstitute) => partnerInstitute?._id === partnerInstituteId
    )
  ) {
    return true;
  }
  return false;
};
export const handlePartnerInstituteFilter = (
  partnerInstituteArray: IPartnerInstitute[],
  courses: IRecommendedCourse[]
) => {
  const filteredPartnerInstitute: IPartnerInstitute[] = [];
  const partnerInstituteId: string[] = [];
  partnerInstituteArray?.forEach((partnerInstitute: IPartnerInstitute) => {
    partnerInstituteId.push(partnerInstitute?._id);
  });
  courses?.forEach((course: IRecommendedCourse) => {
    if (
      partnerInstituteId?.includes(course?.partnerInstitute?._id as string) &&
      !checkPartnerInstituteAlreadyPresent(
        filteredPartnerInstitute,
        course?.partnerInstitute?._id as string
      )
    ) {
      filteredPartnerInstitute.push(course?.partnerInstitute as unknown as IPartnerInstitute);
    }
  });
  return filteredPartnerInstitute;
};

// Helper: checks if an ISO date is at least `days` old from the provided `now` (defaults to current time)
export const isAtLeastNDaysOld = (
  isoDate: string | Date,
  days = 10,
  now: Date = new Date()
): boolean => {
  if (!isoDate) return false;
  const d = typeof isoDate === 'string' ? new Date(isoDate) : isoDate;
  if (Number.isNaN(d.getTime())) return false;
  const msDiff = now.getTime() - d.getTime();
  const dayMs = 24 * 60 * 60 * 1000;
  return msDiff >= days * dayMs;
};
